/* eslint-disable max-len */
import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';

export const SbotdMessaging = () => {
  return (
    <div>
      <div className="sui-pb-4">
        <Typography variant="body-sm" align="justify" style={{ wordWrap: 'break-word' }}>
          Are you looking for special deals on the top brand names? Shop the Special Buy of The Day at The Home Depot for daily sales and deals of the day on select appliances, home decor, home improvement items and so much more. Saving money is at the top of everyone’s to-do list, and these one-day sales are a great way to spend less while you stock up on the items you need for your home. Visit The Home Depot website daily for the sale of the day and get access to today’s deals and specials from top brands you love, on products you need.
        </Typography>
      </div>
      <div className="sui-pb-4">
        <Typography variant="body-sm" align="justify" style={{ wordWrap: 'break-word' }}>
          Check out the deal of the day at The Home Depot. When you start shopping, today’s special could be one of the great online deals you receive on select appliances for your kitchen or laundry room refresh. Explore furniture deals, get deep discounts on home decor and decorative accents, and take advantage of specials deals on housewares, cooking tools, and small appliances.
        </Typography>
      </div>
      <div className="sui-pb-4">
        <Typography variant="body-sm" align="justify" style={{ wordWrap: 'break-word' }}>
          Get excited for what you’ll find in today’s deals. Look out for a daily deal on items for all of your home improvement needs, inside and out. You could find the tool deal of the day or electronic daily deals for less than anywhere else. The deal of the day might just be something you’ve had your eye on, but you have to visit the site frequently to discover the sale of the day. Now is the time to add to your collection while spending less at the same time.
        </Typography>
      </div>
      <div className="sui-pb-2">
        <Typography variant="body-sm" align="justify" style={{ wordWrap: 'break-word' }}>
          How can you be the first to know about these online deals? Join our daily sale mailing list and get deals for today sent straight to your inbox. You’ll snag them first and for the lowest price. Shop the Special Buy of The Day and see how much you can save at The Home Depot.
        </Typography>
      </div>
    </div>
  );
};
